import { toast } from 'react-toastify';
import { IHistory } from 'src/interfaces';

import { setLoading, setSuccess } from '../actions/loadingActions';
import { FORM_SUBMISSION_SUCCESS, SUBMISSION_FAILED } from '../constants/generals';
import { PlantModel } from '../model/PlantModel';
import { ISettledFormModelProps, SettledFormModel, IOutfall } from '../model/SettledFormModel';
import { getCurrentUserUUID } from '../utils/generalUtils';
import { delDev, getDev, postDev, putDev } from '../utils/HTTPDev';

export async function getAllPlantsByRegion(userId = getCurrentUserUUID(), region = 'All') {
    PlantModel.deleteAll();
    setLoading('PlantListPage');
    try {
        const response = await getDev(`/plantsbyregion/${region || 'All'}/${userId}`);
        (response.data.data instanceof Array ? response.data.data : []).forEach(instance => {
            const newInstance = marshallPlantInstance(instance);
            new PlantModel(newInstance).$save();
        });
        setSuccess('PlantListPage');
    } catch (error) {
        setSuccess('PlantListPage');
        throw error;
    }
}

export async function getPlantDetails(plantId: string) {
    setLoading('PlantDetailsPage');
    try {
        const response = await getDev(`/plant/${plantId}`, {
        });
        const newInstance = marshallPlantInstance(response.data.data);
        new PlantModel(newInstance).$save();
        setSuccess('PlantDetailsPage');
    } catch (error) {
        setSuccess('PlantDetailsPage');
        throw error;
    }
}

function marshallPlantInstance(instance) {
    const newInstance = {
        id: instance && instance.UniqueId || '',
        Street: instance && instance.Street || '',
        Country: instance && instance.Country || '',
        State: instance && instance.State || '',
        PlantId: instance && instance.PlantId || '',
        Plant_Region: instance && instance.Plant_Region || '',
        Zip: instance && instance.ZipCode || '',
        City: instance && instance.City || '',
        Plant_Name: instance && instance.Plant_Name || '',
        Inspections: {
            DailyForm: instance && (instance.Inspections.indexOf('DailyForm') > -1 ||
                instance.Inspections.indexOf('Daily Form') > -1),
            PlantPreventive: instance && (instance.Inspections.indexOf('PlantPreventive') > -1 ||
                instance.Inspections.indexOf('Plant Preventive') > -1),
            MonthlySPCC: instance && (instance.Inspections.indexOf('MonthlySPCC') > -1 ||
                instance.Inspections.indexOf('Monthly SPCC') > -1),
            MonthlySpillLogs: instance && (instance.Inspections.indexOf('MonthlySpillLogs') > -1 ||
                instance.Inspections.indexOf('Monthly SpillLogs') > -1),
            MonthlySW: instance && (instance.Inspections.indexOf('MonthlySW') > -1 ||
                instance.Inspections.indexOf('Monthly SW') > -1),
            MonthlyUSTRect: instance && (instance.Inspections.indexOf('MonthlyUSTRect') > -1 ||
                instance.Inspections.indexOf('Monthly UST Rect') > -1),
            MonthlyUSTSpill: instance && (instance.Inspections.indexOf('MonthlyUSTSpill') > -1 ||
                instance.Inspections.indexOf('Monthly UST Spill') > -1),
            QTRVisual: instance && (instance.Inspections.indexOf('QTRVisual') > -1 ||
                instance.Inspections.indexOf('Quarterly Visual') > -1),
            ShopInspection: instance && (instance.Inspections.indexOf('ShopInspection') > -1 ||
                instance.Inspections.indexOf('Quarterly Shop') > -1),
        },
        Outfalls: {
            Outfall1: instance &&
                (instance.Outfalls.indexOf('Tank1') > -1 || instance.Outfalls.indexOf('Outfall1') > -1),
            Outfall2: instance &&
                (instance.Outfalls.indexOf('Tank2') > -1 || instance.Outfalls.indexOf('Outfall2') > -1),
            Outfall3: instance &&
                (instance.Outfalls.indexOf('Tank3') > -1 || instance.Outfalls.indexOf('Outfall3') > -1),
            Outfall4: instance &&
                (instance.Outfalls.indexOf('Tank4') > -1 || instance.Outfalls.indexOf('Outfall4') > -1),
            Outfall5: instance &&
                (instance.Outfalls.indexOf('Tank5') > -1 || instance.Outfalls.indexOf('Outfall5') > -1),
            Outfall6: instance &&
                (instance.Outfalls.indexOf('Tank6') > -1 || instance.Outfalls.indexOf('Outfall6') > -1),
        }
    };
    return newInstance;
}

export async function submitPlantForm(plantData, history: IHistory) {
    try {
        const response = await postDev('/plant', plantData);
        history.push('/maintenance');
        toast.success(FORM_SUBMISSION_SUCCESS, {
            position: toast.POSITION.TOP_CENTER,
            onClose: () => history.push('/maintenance'),
            className: 'success-toast',
            autoClose: 2000
        });
        await getAllPlantsByRegion(getCurrentUserUUID());
        return response;
    } catch (error) {
        toast.error(SUBMISSION_FAILED, {
            position: toast.POSITION.TOP_CENTER,
            className: 'failed-toast'
        });
        throw error;
    }
}

export async function getPlantsByRegion(region, userId = getCurrentUserUUID()) {
    try {
        const response = await getDev(`plantsbyregion/${region}/${userId}`);
        return (response.data.data || []);
    } catch (error) {
        toast.error(SUBMISSION_FAILED, {
            position: toast.POSITION.TOP_CENTER,
            className: 'failed-toast'
        });
        throw error;
    }
}

export async function updatePlant(plantId: string, data: Object, history: IHistory) {
    try {
        const response = await putDev(`/plant/${plantId}`, data);

        toast.success(response.data.message, {
            position: toast.POSITION.TOP_CENTER,
            className: 'success-toast',
            onClose: () => history.push('/maintenance'),
            autoClose: 1000
        });
        await getAllPlantsByRegion(getCurrentUserUUID());
        return response;
    } catch (error) {
        toast.error(SUBMISSION_FAILED, {
            position: toast.POSITION.TOP_CENTER,
            className: 'failed-toast'
        });
        throw error;
    }
}

function marshallInCompleteOutfalls(Outfalls) {
    let outfalls = [];
    for (const key in Outfalls) {
        if (!Outfalls[key]) {
            outfalls.push(key);
        }
    }
    return outfalls;
}

function marshallOutfalls(Outfalls) {
    let outfalls: IOutfall = {};
    for (const key in Outfalls) {
        if (!Outfalls[key]) {
            outfalls[key] = false;
        } else {
            outfalls[key] = Outfalls[key];
        }
    }
    return outfalls;
}
export async function getSettledForms(date: string, plantUUID: string) {
    try {
        const response = await getDev(`/completedtype/${date}/${plantUUID}`);
        const { props: { Inspections } } = PlantModel.get(plantUUID);
        const instance: ISettledFormModelProps = {
            id: plantUUID,
            MonthlySW: Inspections.MonthlySW && (response.data.data.MonthlySW || ''),
            MonthlyUSTRect: Inspections.MonthlyUSTRect && (response.data.data.MonthlyUSTRect || ''),
            MonthlyUSTSpill: Inspections.MonthlyUSTSpill && (response.data.data.MonthlyUSTSpill || ''),
            ShopInspection: Inspections.ShopInspection && (response.data.data.ShopInspection || ''),
            DailyForm: Inspections.DailyForm && (response.data.data.DailyForm || ''),
            PlantPreventive: Inspections.PlantPreventive && (response.data.data.PlantPreventive || ''),
            MonthlySpillLogs: Inspections.MonthlySpillLogs && (response.data.data.MonthlySpillLogs || ''),
            QTRVisual: Inspections.QTRVisual && (response.data.data.QTRVisual || ''),
            MonthlySPCC: Inspections.MonthlySPCC && (response.data.data.MonthlySPCC || ''),
            MonthlyPPM: Inspections.MonthlyPPM && (response.data.data.MonthlyPPM || ''),
            InCompleteOutfalls: marshallInCompleteOutfalls(response.data.data.Outfalls),
            Outfalls: marshallOutfalls(response.data.data.Outfalls)
        };
        new SettledFormModel(instance).$save();
    } catch (error) {
        toast.error(SUBMISSION_FAILED, {
            position: toast.POSITION.TOP_CENTER,
            className: 'failed-toast'
        });
        throw error;
    }
}

export async function deleteForm(date: string, plantUID: string, formType: string, instance, outfall?: string, ) {
    try {
        const response = await delDev(`/deleteform/${date}/${plantUID}/${formType}/${outfall || 'na'}`);
        toast.error((response.data.message || 'Form deleted successfully...!!!'), {
            position: toast.POSITION.TOP_CENTER,
            className: 'success-toast'
        });
        setLoading('InspectionFooter');
        await getSettledForms(date, plantUID);
        setSuccess('InspectionFooter');
        return response;
    } catch (error) {
        toast.error(SUBMISSION_FAILED, {
            position: toast.POSITION.TOP_CENTER,
            className: 'failed-toast'
        });
        instance.setState({
            isLoading: false
        });
        document.body.click();
        throw error;
    }
}

export async function deletePlant(plantUID: string, history: IHistory) {
    setLoading('PlantDetailsPage');
    try {
        const response = await delDev(`/plant/${plantUID}`);
        const plantInstance = PlantModel.get(plantUID);
        new PlantModel(plantInstance.props).$delete();
        await getAllPlantsByRegion('All');
        toast.success((response.data.message || 'Plant deleted successfully...!!!'), {
            position: toast.POSITION.TOP_CENTER,
            className: 'success-toast',
            autoClose: 2000,
            onClose: () => history.push('/maintenance')
        });
        setSuccess('PlantDetailsPage`');
    } catch (error) {
        toast.error(SUBMISSION_FAILED, {
            position: toast.POSITION.TOP_CENTER,
            className: 'failed-toast'
        });
        document.body.click();
        setSuccess('PlantDetailsPage`');
        throw error;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/plantService.ts